<template>
  <div id="app">
    <meta http-equiv="X-UA-Compatible" content="IE=EmulateIE7">

    <transition :name="transitionName">
      <router-view/>
    </transition>

  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    // HelloWorld,
    // Show
  },
  data(){
    return{
      transitionName:'slide-left'
    }
  },
  // watch:{
  //   $route(to,from){
  //     if(to.meta.index > from.meta.index){
  //       this.transitionName = 'slide-left';
  //     }else if(to.meta.index < from.mata.index){
  //       this.transitionName = 'slide-right';
  //     }else{
  //       this.transitionName = ''
  //     }
  //     this.$message(this.transitionName)
  //   }
  // }
}
</script>

<style>
*{
  margin: 0px;
  padding: 0px;
}

html,body{
  height: 100%;
  font-family: 'Arial';
}

#app {
  font-family: 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  margin: 0px;
  padding: 0px;
/*  height: 100%;
  height: auto !important;
  width: 100%;
  background: url('./assets/image/home/home_back.jpg') no-repeat;

  -moz-background-size: 100% 100%;
  background-size: 100% 100%; */
}

/* */



</style>



// WEBPACK FOOTER //
// src/App.vue